import { Tooltip } from '@leroy-merlin-br/backyard-react-ui'

import { ServicesBadge as Icon } from 'reactShared/components/ServicesBadge'

import { useResize } from 'reactUtils/hooks/use-resize'

import * as S from './styled'

const ServicesBadge = () => {
  const [isMobile] = useResize()

  return (
    <Tooltip
      placement={isMobile ? 'right' : 'left'}
      content={
        <S.Content>
          Serviço de instalação disponível para compra no carrinho
        </S.Content>
      }
    >
      <S.ServicesBadge>
        <Icon />
      </S.ServicesBadge>
    </Tooltip>
  )
}

export default ServicesBadge
